webpackJsonp([245999391066784],{

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookWebsocketsSocketIo = __webpack_require__(110);
	
	var _LoreHookWebsocketsSocketIo2 = _interopRequireDefault(_LoreHookWebsocketsSocketIo);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookWebsocketsSocketIo2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'lore-hook-websockets-socketio'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Source code for this hook can be found on GitHub ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-hook-websockets-socketio' },
	        'at this link'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook is built on top of the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-websockets' },
	        'lore-websockets'
	      ),
	      ' library and implements the interface for socket.io.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook does two things:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'It provides an implementation of the ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/lore/lore/tree/master/packages/lore-websockets' },
	          'lore-websockets'
	        ),
	        ' interface that can be used with socket.io.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Provides a set of methods and dispatchers that can be used by default with any model in the application (using some overridable conventions)'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'See the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples/websockets' },
	        'websockets example'
	      ),
	      ' to see this hook in action.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Implementing support for socket.io is fairly straight forward. The implementation just needs to know the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'serverUrl'
	      ),
	      ' (which is the root URL for the socket.io server), the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'namespace'
	      ),
	      ' (if your server uses one) and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'event'
	      ),
	      ' that will be emitted when CRUD operations occur for the desired resource.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import io from \'socket.io-client\';\n      import { WebSocketConnection } from \'lore-websockets\';\n\n      export default WebSocketConnection.extend({\n\n        // These three values are provided by the project configuration or conventions\n        serverUrl: \'http://localhost:1337\',\n        namespace: \'/posts\',\n        event: \'post\',\n\n        connect: function() {\n          const url = this.serverUrl + this.namespace;\n          this.socket = io(url);\n        },\n\n        subscribe: function() {\n          this.socket.on(this.event, this.dispatch);\n        },\n\n        unsubscribe: function() {\n          this.socket.off(this.event, this.dispatch);\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Methods and Dispatchers'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The code below illustrates the general setup process used when the hook creates the WebSocket instance:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // these "guess" the namespace and event based on conventions\n      // can be provided explicitly by the user\n      var conventions = {\n        namespace: config.pluralize ? `${pluralize(modelName)}` : `${modelName}`,\n        event: modelName\n      };\n\n      // these three dispatchers are provided by default to update the Redux store\n      // based on data that was created, updated or deleted by other users.\n      var dispatchers = {\n        created: blueprints.dispatchers.created(modelName, Model)(store),\n        updated: blueprints.dispatchers.updated(modelName, Model)(store),\n        destroyed: blueprints.dispatchers.destroyed(modelName, Model)(store)\n      };\n\n      // override the SocketIo WebSocketConnection with conventions and configuration\n      var CustomWebSocketConnection = SocketIoWebSocketConnection.extend(_.extend(conventions, config));\n\n      // make the connection accessible under lore.websockets, i.e. lore.websockets.post for example.\n      lore.websockets[modelName] = new CustomSocketIoWebSocketConnection(dispatchers);\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you want to listen for events during the entire lifecycle of your application, a good place to connect and listen for data is within the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'componentDidMount'
	      ),
	      ' method of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Master'
	      ),
	      ' component, like so:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Master.js\n      createReactClass({\n        componentDidMount: function() {\n          lore.websockets.post.connect();\n          lore.websockets.post.subscribe();\n        },\n\n        componentWillUnmount: function() {\n          lore.websockets.post.unsubscribe();\n        }\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Calling ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.websockets.post.connect()'
	      ),
	      ' will cause the websocket instance to connect with the server. Calling ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.websockets.post.subscribe()'
	      ),
	      ' will cause it to listen for the event it was configured for, such as events called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' that contain data about Post resources that have been created, updated or deleted by other users.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-websockets-socketio-index-js-59d012ec9eac3f43f835.js